import React from 'react'

import { FormControl, FormLabel, MenuItem, Select, SelectProps } from '@material-ui/core'

import { BootstrapInput } from './BootstrapInput'
import { useMatchProductsButtonStyles } from './MatchProductsButton'

import { useDefaultMenuItemStyles } from '../hooks/defaultSelectStylesHook'

import { required } from '../common/objectUtils'
import { fixMsAppScrollProps } from '../common/msAppUtils'
import { ensureNumber, throwError, valuesOfNumericEnum } from '../common/tsUtils'

import { MsProductProp } from '../server/mpsklad_core/Models/MsProductProp'

export type MatchMsProductPropSelectorProps = {
  msProp: MsProductProp

  onChange: (value: MsProductProp) => void
}

export const msProductMatchingProps = [
  [MsProductProp.Id, 'GUID'],
  [MsProductProp.Code, 'Код'],
  [MsProductProp.Article, 'Артикул'],
  [MsProductProp.Name, 'Название'],
  [MsProductProp.BarcodeGtin, 'Штрихкод GTIN'],
  [MsProductProp.BarcodeEan8, 'Штрихкод EAN8'],
  [MsProductProp.BarcodeEan13, 'Штрихкод EAN13'],
  [MsProductProp.BarcodeCode128, 'Штрихкод Code128']
] as const

const msProductPropValues = valuesOfNumericEnum(MsProductProp)

export const MatchMsProductPropSelector =
  ({msProp, onChange}: MatchMsProductPropSelectorProps) => {
    const classes = useMatchProductsButtonStyles()
    const menuItemClasses = useDefaultMenuItemStyles()

    const onChangeInner: SelectProps['onChange'] =
      ({target: {value}}) => {
        const numberValue = ensureNumber(value)

        const enumValue: MsProductProp =
          msProductPropValues.includes(numberValue)
          ? numberValue
          : throwError(`Bad value of MsProductProp: ${numberValue}`)

        const newValueProp = required(
          msProductMatchingProps.find(
            ([propValue]) => propValue === enumValue
          ))

        onChange(newValueProp[0])
      }

    return (
      <FormControl fullWidth>
        <FormLabel component="legend" className={classes.helperText}>
          <span className={classes.dash}>—</span>
          Поле товара в МоёмСкладе
        </FormLabel>

        <Select
          labelId="ms-label"
          value={msProp}
          onChange={onChangeInner}
          MenuProps={fixMsAppScrollProps}
          input={<BootstrapInput/>}
        >
          {
            msProductMatchingProps.map(
              ([propValue, propName]) =>
                <MenuItem
                  className={menuItemClasses.menuItem}
                  key={propValue}
                  value={propValue}
                >
                  {propName}
                </MenuItem>
            )
          }
        </Select>
      </FormControl>
    )
  }